import { useEffect, useRef } from "react"
import { VideoDisplay } from "@/components/video-display"
import { isAttachableLocalTrack, isDetachableLocalTrack } from "@/modules/video-call/helpers/track.helper"
import useVideoCallStore from "@/stores/useVideoCallStore"

const LocalVideo = () => {
  const videoRef = useRef(null)
  const localTracks = useVideoCallStore((state) => state.localTracks)

  useEffect(() => {
    const videoTrack = localTracks.find((t) => t.kind === "video")
    const videoElement = videoRef.current

    if (videoElement && isAttachableLocalTrack(videoTrack)) {
      videoTrack.attach(videoElement)
    }

    return () => {
      if (videoElement && isDetachableLocalTrack(videoTrack)) {
        videoTrack.detach(videoElement)
      }
    }
  }, [localTracks])

  return (
    <div className="absolute top-4 right-4 flex h-50 w-50 items-center justify-center rounded-lg bg-black text-white">
      <VideoDisplay ref={videoRef} />
    </div>
  )
}

export { LocalVideo }
